import {useEffect, useState} from 'react';

// Standardises inline validation across every Create Listing stage.
//
// Usage inside a stage:
//   const {errors, validate, clearError} = useStageValidation();
//   const handleSave = () => {
//     const ok = validate([
//       {field: 'website', valid: !!website, message: 'Website is required'},
//       ...
//     ]);
//     if (!ok) return;
//     dispatch(...); navigate(...);
//   };
//
// - `errors` is an object keyed by field name -> message. Pass
//   `errors.website` to <FieldError message={...} />.
// - `validate(rules)` records the failing rules, returns true only when all
//   pass. When it fails it scrolls the first inline error into view.
// - `clearError(field)` removes a single field's error (call it in onChange
//   so the message clears as the user fixes the field).
export const useStageValidation = () => {
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (Object.keys(errors).length) {
      const el = document.querySelector(
        '.stage-field-error, .stage-error-summary',
      );
      el?.scrollIntoView({behavior: 'smooth', block: 'center'});
    }
  }, [errors]);

  const validate = rules => {
    const next = {};
    rules.forEach(({field, valid, message}) => {
      if (!valid) next[field] = message;
    });
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const clearError = field =>
    setErrors(prev => {
      if (!prev[field]) return prev;
      const next = {...prev};
      delete next[field];
      return next;
    });

  return {errors, setErrors, validate, clearError};
};
